module.exports = __webpack_public_path__ + "6cb56247acffda1e8ae7b1abc33237bb.svg";